import { render, staticRenderFns } from "./RemoteConsultationTableCmp5.vue?vue&type=template&id=05797674&"
import script from "./RemoteConsultationTableCmp5.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports